import { ObjectizerModel } from '@leverege/condition';
import { ns } from '@leverege/i18n';
const {
  t,
  tIcon
} = ns('condition.CopyRuleAction');
export default {
  id: 'condition.objectizer.CopyRuleAction',
  matches: {
    client: 'condition.ObjectizerEditor',
    use: 'objectizerActionBar'
  },
  layout: {
    group: ['more'],
    groupIcons: ['fa fa-ellipsis-v fa-fw'],
    sort: 'copy'
  },
  appearance(context) {
    return {
      name: t('name'),
      icon: tIcon('icon', 'fa fa-copy fa-fw')
    };
  },
  handles(context) {
    return true;
  },
  perform: async ({
    context
  }) => {
    const {
      value: rule
    } = context;
    const content = JSON.stringify(rule);
    await navigator.clipboard.write([new ClipboardItem({
      'text/plain': new Blob([content], {
        type: 'text/plain'
      })
    })]);
  }
};